module.exports = __webpack_public_path__ + "img/norway.93fcc422.svg";